import { selectors } from './init.js';
import { initMap, showLocationInMap } from './map.js';

declare global {
	interface DocumentEventMap {
		mcflyFilterChange: CustomEvent<{ filterValue: string }>;
	}
}

export const initEventListeners = () => {
	// Event listeners
	document.addEventListener('mcflyFilterChange', (e) => {
		const category = e.detail.filterValue;
		const firstItemInList = document.querySelector(`${selectors.locationList} .location__item[data-cat="${category}"]`);
		if (firstItemInList) {
			const locationID = firstItemInList.getAttribute('id');
			if (locationID) {
				showLocationInMap(locationID);
			}
		}
	});

	// Listen for theme color change
	document.addEventListener('colorModeChange', initMap);
	initMap();
};
